// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    delete: "Delete",
    twoColumnBlock: "2-Column Block",
    conditional: "Conditional",
    leftColumn: "Left Column",
    rightColumn: "Right Column",
    styled: "Styled",
    addComponent: "Add Component",
    dropComponentHere: "Drop component here",
    noComponents: "No components",
    required: "Required",
    movingComponent: "Moving component...",
    costProjectionChart: "Cost Projection Chart",
    columnSettings: "Column Settings",
    duplicateComponent: "Duplicate component",
  },
  nb_NO: {
    settings: "Innstillinger",
    delete: "Slett",
    twoColumnBlock: "2-kolonneblokk",
    conditional: "Betinget",
    leftColumn: "Venstre kolonne",
    rightColumn: "Høyre kolonne",
    styled: "Stilsatt",
    addComponent: "Legg til komponent",
    dropComponentHere: "Slipp komponent her",
    noComponents: "Ingen komponenter",
    required: "Påkrevd",
    movingComponent: "Flytter komponent...",
    costProjectionChart: "Kostnadsframskrivning",
    columnSettings: "Kolonneinnstillinger",
    duplicateComponent: "Dupliser komponent",
  },
} as const;
